import { Compass, Stack, SealCheck } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const CARDS = [
    { icon: Compass, title: "Less Uncertainty", text: "Understand your options and your journey." },
    { icon: Stack, title: "Less Coordination", text: "One place to manage the moving pieces of international care." },
    { icon: SealCheck, title: "More Confidence", text: "Access trusted healthcare providers and human support throughout the journey." },
];

export default function PatientExperience() {
    return (
        <section data-testid="patient-experience-section" className="py-28 lg:py-36 bg-tint-slate noise-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
                    <div className="lg:col-span-7">
                        <SectionHeading
                            chapter="10"
                            eyebrow="Patient Experience"
                            title="Designed around the patient."
                            testid="patient-experience-heading"
                        />
                        <div className="mt-14 space-y-5">
                            {CARDS.map((c, i) => (
                                <Reveal key={c.title} delay={0.1 * i}>
                                    <div
                                        data-testid={`patient-card-${i + 1}`}
                                        className="group flex items-start gap-6 rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-[transform,box-shadow] duration-300"
                                    >
                                        <div className="w-12 h-12 shrink-0 rounded-2xl bg-tint-green flex items-center justify-center text-brand-green">
                                            <c.icon size={24} weight="duotone" />
                                        </div>
                                        <div>
                                            <h3 className="font-heading text-xl font-semibold text-brand-blue">{c.title}</h3>
                                            <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{c.text}</p>
                                        </div>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={0.2}>
                            <div className="relative">
                                <img
                                    src="https://images.pexels.com/photos/7579823/pexels-photo-7579823.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                                    alt="Doctor consulting an international patient"
                                    loading="lazy"
                                    className="rounded-[1.75rem] w-full h-[460px] lg:h-[560px] object-cover shadow-[0_24px_60px_rgb(10,37,64,0.15)]"
                                    data-testid="patient-experience-image"
                                />
                                <div className="absolute inset-0 rounded-[1.75rem] ring-1 ring-inset ring-brand-blue/10" aria-hidden="true" />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
